import { BrowserRouter } from 'react-router-dom';
import AppRouter from './router';
import { Provider } from 'react-redux';
import ModalProvider from './contexts/modalContext';
import DrawerProvider from './contexts/drawerContext';
import { store } from './redux/store';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ConfigProvider, ja_JP, App as AppProvider } from 'core-ui';
import theme from './theme';
import 'react-color-palette/css';

const queryClient = new QueryClient();

const App = () => {
  return (
    <ConfigProvider
      theme={theme}
      locale={ja_JP}
      autoInsertSpaceInButton={false}
    >
      <AppProvider>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <ModalProvider>
                <DrawerProvider>
                  <AppRouter />
                </DrawerProvider>
              </ModalProvider>
            </Provider>
          </QueryClientProvider>
        </BrowserRouter>
      </AppProvider>
    </ConfigProvider>
  );
};

export default App;
